import React from "react";

const Unlocked = () => (
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 7H6V4a2 2 0 114 0h1a3 3 0 00-6 0v3H4a1 1 0 00-1 1v6a1 1 0 001 1h8a1 1 0 001-1V8a1 1 0 00-1-1zm0 7H4V8h8v6z" fill="#fff" fillOpacity=".87" />
  </svg>
);

export default Unlocked;
